import { StyleSheet, View } from 'react-native';

import { Skeleton } from 'components/ui/skeleton';
import { primitive, spacing } from 'styles/constants';
export const LoyaltyHistoryHeaderSkeleton = () => {
  return (
    <View style={styles.container}>
      <View style={styles.top}>
        <Skeleton shape="rectangle" style={{ height: 53, borderRadius: 12 }} />
        <Skeleton shape="rectangle" style={{ width: '90%' }} />
      </View>
      <View style={styles.bottom}>
        <Skeleton shape="rectangle" style={{ width: '70%' }} />
        <Skeleton shape="rectangle" style={{ width: '60%', marginTop: 0 }} />
        <Skeleton shape="circle" style={{ width: '90%', height: 36 }} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: primitive.$blackOpacity10,
    borderRadius: 8,
  },
  top: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.$8,
    borderBottomWidth: 1,
    borderColor: primitive.$blackOpacity30,
    paddingVertical: spacing.$2,
  },
  bottom: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: spacing.$2,
  },
});
